
(() => {
  const JSON_URL =
    'https://cdn.shopify.com/s/files/1/1030/6768/1133/files/printer_categories_23oct2026.json?v=1792735327';

  function init() {
    const trigger = document.querySelector(
      '.cf-nav-item.cartridge-finder-menu'
    );

    const dropdown = document.querySelector(
      '[data-header-finder-dropdown]'
    );

    if (!trigger || !dropdown) {
      console.error('Cartridge Finder: trigger or dropdown not found.', {
        trigger,
        dropdown
      });
      return;
    }

    if (dropdown.dataset.headerBound === 'true') return;
    dropdown.dataset.headerBound = 'true';

    const brand = dropdown.querySelector('[data-brand]');
    const type = dropdown.querySelector('[data-type]');
    const model = dropdown.querySelector('[data-model]');
    const find = dropdown.querySelector('[data-find]');
    const status = dropdown.querySelector('[data-status]');

    if (!brand || !type || !model || !find) {
      console.error('Cartridge Finder: required select/button elements are missing.');
      return;
    }

    let data = {};
    let collectionHandle = '';
    let open = false;

    function message(text) {
      if (status) status.textContent = text;
    }

    function fill(select, placeholder, options) {
      select.replaceChildren(new Option(placeholder, ''));

      options.forEach(({ label, value }) => {
        select.add(new Option(label, value));
      });

      select.disabled = options.length === 0;
    }

    function resetModel() {
      fill(model, '3. Select Printer Model', []);
      collectionHandle = '';
      find.disabled = true;
    }

    function positionDropdown() {
      const rect = trigger.getBoundingClientRect();

      dropdown.style.position = 'fixed';
      dropdown.style.top = `${rect.bottom}px`;

      const width = Math.min(520, window.innerWidth - 24);
      const left = Math.max(
        12,
        Math.min(
          rect.left + rect.width / 2 - width / 2,
          window.innerWidth - width - 12
        )
      );

      dropdown.style.left = `${left}px`;
      dropdown.style.width = `${width}px`;
      dropdown.style.maxWidth = `${width}px`;
    }

    function setOpen(value) {
      open = value;

      if (open) {
        positionDropdown();
      }

      dropdown.classList.toggle('finder-open', open);
      dropdown.setAttribute('aria-hidden', String(!open));
      trigger.setAttribute('aria-expanded', String(open));
    }

    trigger.setAttribute('aria-expanded', 'false');

    // Support a trigger that is an <li>, a link, or a button.
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setOpen(!open);
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        if (event.target === trigger) {
          event.preventDefault();
          setOpen(!open);
        }
      }
    });

    trigger.addEventListener('mouseenter', () => {
      if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
        setOpen(true);
      }
    });

    dropdown.addEventListener('mouseenter', () => {
      if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
        setOpen(true);
      }
    });

    
let closeTimer;

function cancelClose() {
  clearTimeout(closeTimer);
}

function scheduleClose() {
  cancelClose();

  closeTimer = setTimeout(() => {
    const hoveringTrigger = trigger.matches(':hover');
    const hoveringDropdown = dropdown.matches(':hover');

    if (!hoveringTrigger && !hoveringDropdown) {
      setOpen(false);
    }
  }, 400);
}

trigger.addEventListener('mouseenter', () => {
  cancelClose();
  setOpen(true);
});

trigger.addEventListener('mouseleave', scheduleClose);

dropdown.addEventListener('mouseenter', () => {
  cancelClose();
});

dropdown.addEventListener('mouseleave', scheduleClose);


    document.addEventListener('click', (event) => {
        const clickedTrigger = trigger.contains(event.target);
        const clickedDropdown = dropdown.contains(event.target);

        if (!clickedTrigger && !clickedDropdown) {
            setOpen(false);
        }
    });

    // Keep the finder open while selecting dropdown options.
    dropdown.addEventListener('click', (event) => {
        event.stopPropagation();
    });

    dropdown.querySelectorAll('select').forEach((select) => {
        select.addEventListener('click', () => {
            cancelClose();
        });

        select.addEventListener('change', () => {
            cancelClose();
        });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });

    window.addEventListener('resize', () => {
      if (open) positionDropdown();
    });

    window.addEventListener('scroll', () => {
      if (open) positionDropdown();
    }, true);

    // Load the JSON and populate the dropdowns.
    async function loadData() {
      message('Loading printer data...');

      try {
        const response = await fetch(JSON_URL);

        if (!response.ok) {
          throw new Error(`JSON request failed: ${response.status}`);
        }

        data = await response.json();

        const brands = Object.keys(data)
          .filter((key) => data[key] && typeof data[key] === 'object')
          .sort((a, b) => a.localeCompare(b));

        fill(
          brand,
          '1. Select Printer Brand',
          brands.map((value) => ({ label: value, value }))
        );

        fill(type, '2. Select Ink or Toner', []);
        resetModel();
        message(brands.length ? '' : 'No printer brands found.');
      } catch (error) {
        console.error('Cartridge Finder JSON error:', error);
        message('Could not load printer data. Check the JSON URL.');
      }
    }

    brand.addEventListener('change', () => {
      const types = Object.keys(data[brand.value] || {})
        .filter((key) => data[brand.value][key] &&
          typeof data[brand.value][key] === 'object')
        .sort((a, b) => a.localeCompare(b));

      fill(
        type,
        '2. Select Ink or Toner',
        types.map((value) => ({ label: value, value }))
      );

      resetModel();
      message('');
    });

    type.addEventListener('change', () => {
      const models = Object.entries(
        data[brand.value]?.[type.value] || {}
      ).filter(([, handle]) =>
        typeof handle === 'string' && handle.trim()
      );

      fill(
        model,
        '3. Select Printer Model',
        models.map(([value]) => ({ label: value, value }))
      );

      model.dataset.collectionMap = JSON.stringify(
        Object.fromEntries(models)
      );

      collectionHandle = '';
      find.disabled = true;
      message('');
    });

    model.addEventListener('change', () => {
      const map = JSON.parse(model.dataset.collectionMap || '{}');

      collectionHandle = (map[model.value] || '')
        .trim()
        .replace(/^\/+|\/+$/g, '')
        .replace(/^collections\//, '');

      find.disabled = !collectionHandle;
      message('');
    });

    find.addEventListener('click', () => {
      if (!collectionHandle) {
        message('Please select a printer brand, type, and model.');
        return;
      }

      setOpen(false);
      window.location.href =
        '/collections/' + encodeURIComponent(collectionHandle);
    });

    loadData();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
